const ObjectList = [
    {
        contestObjectiveKey: 'idea',
        contestObjectiveValue: '아이디어 협업',
        status: 'N',
    },
    {
        contestObjectiveKey: 'design',
        contestObjectiveValue: '디자인 협업',
        status: 'N',
    },
    {
        contestObjectiveKey: 'tech',
        contestObjectiveValue: '기술구매 M&A',
        status: 'N',
    },
    {
        contestObjectiveKey: 'order',
        contestObjectiveValue: '주문형 생산',
        status: 'N',
    },
    {
        contestObjectiveKey: 'online',
        contestObjectiveValue: '온라인 마케팅',
        status: 'N',
    },
    {
        contestObjectiveKey: 'recruit',
        contestObjectiveValue: '채용',
        status: 'N',
    },
    {
        contestObjectiveKey: 'etc',
        contestObjectiveValue: '',
        status: 'N',
    },
]

export default ObjectList